/*
	File: hash-manager.js
	Author: D McCleod
	Created: 2/08/2017
	Modified:
	Description: controller for hash even changes and returning current hash
*/

import { isInfiniteScroll } from './init-slideshow';
import { pagination } from './pagination';
import { goToSlide, toggleSlideClasses, scrollTo } from './slider-events';
import { infiniteScrollTracking } from './infinitescroll-tracking';
import { sticky } from './sticky-header';

const hash_prefix = 'slide_';
// TODO: convert hash to number parseInt(hash.substr(prefix.length + 1))

var currentHash = 1,
	hashHistory = [],
	lastHash = currentHash;


function getHash(){
	let hash = parseInt(window.location.hash.substr(1));
    // default to first slide if hash it not a number or greater than total slides
	// #1 hash causes a bug in app when returning back to landing page using back button, just use current hash
    hash = isNaN(hash) ? 1 : (hash > window.slideShow.slideCount ? 1: hash);
    currentHash = hash;
	return hash;
}

function setLastHash(){
    lastHash = hashHistory.length === 1 ? hashHistory[0] : hashHistory[hashHistory.length - 2];
    return lastHash;
}

function bindHashListener(){
	// bind custom event listener to the window hashchange event
	$(window)
        .on('hashchange', function(event, data) {
			getHash();

			if(isInfiniteScroll) {
				infiniteScrollTracking.scrollToSlide(currentHash);
			} else {
				// only go to slide if triggered by hash change, slick will handle it's own update
				if(window.slideShow.slickNavEngaged){
					window.slideShow.slickNavEngaged = false;
				} else {
					if(!isMscpApp && sticky.props.classSet) scrollTo(sticky.props.returnHeight);
					goToSlide(currentHash);
                    // update internal history
                    hashHistory.push(currentHash);
                    setLastHash();
				}

				// set pagination to current slide
				pagination.currentSlideText.trigger('pagination:update', { 'currentSlide': currentHash });

				// adding + 1 to equalize slide index with slide presentation number, either first-slide or last-slide
				toggleSlideClasses(currentHash);
			}
        });
}



export { currentHash, hashHistory, lastHash, setLastHash, getHash, bindHashListener };